export default function (func: (...args: any) => void, wait: number) {
  let lock = false

  return function (...args: any) {
    // @ts-ignore
    let context: any = this

    if (lock) return

    func.apply(context, args)

    setTimeout(() => (lock = false), wait)

    lock = true
  }
}
